import { useShallow } from 'zustand/shallow'

import { useStore } from '@app/store'
import type { BoundedState, StoreDomainObject } from '@app/store/types'

const useGetObjects = <T extends keyof BoundedState>(type: T): StoreDomainObject<T>[] | undefined =>
  useStore(useShallow((state) => Object.values(state[type] || {})))

export default useGetObjects
